<template>
  <v-app-bar app color="secondary" class="px-sm-10" dark>
    <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <div class="d-flex align-center"><h3> {{appBarStore.title}} </h3></div>

    <v-spacer></v-spacer>

    <div v-for="(item, i) in appBarStore.actionItems" :key="i">
      <v-btn
        :to="item.routeName ? { name: item.routeName } : item.routePath"
        @click.prevent="handleAppBarClick(item)"
        text
      >
        <span class="d-none d-sm-block mr-2">{{item.label}}</span>
        <v-icon>{{item.icon}}</v-icon>
      </v-btn>
    </div>
  </v-app-bar>

  <v-navigation-drawer
    v-model="drawer"
    class="text-left"
    color="accent"
    temporary>
    <v-list nav>
      <template v-for="group in items" :key="group.group">
        <v-list-subheader 
          v-if="group.group"
          class="text-text-light"
        >{{ group.group }}</v-list-subheader>
        <v-list-item
          v-for="item in group.items"
          :key="item.title"
          :to="item.routeName ? { name: item.routeName } : null"
          :href="item.href ? item.href : null"
          :disabled="item.disabled"
          :prepend-icon="item.icon || null"
          :title="item.title"
          @click="handleNavItemClick(item.action)"
        />
      </template>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn
          href="https://adventurawr.ai/privacy-policy"
          target="_blank"
          variant="text"
          block
        >
          Privacy Policy
        </v-btn>
        <v-btn
          href="https://adventurawr.ai/terms-and-conditions"
          target="_blank"
          variant="text"
          block
        >
          Terms and Conditions
        </v-btn>
      </div>

      <v-sheet 
        class="pa-4 d-flex justify-center"
        color="tertiary"
      >
        <v-row align="center" justify="center">
          <v-col cols="auto">
            <v-btn 
              href="https://discord.gg/XySHrQR4ew"
              target="_blank"
              variant="tonal"
              icon
            >
              <v-icon class="social-icon">
                <i class="fab fa-discord"></i>
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn 
              href="https://facebook.com/adventurawr"
              target="_blank"
              variant="tonal"
              icon
            >
              <v-icon class="social-icon">
                <i class="fab fa-facebook"></i>
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { getAuth, signOut } from 'firebase/auth'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { appBarStore } from '@/store/AppBarStore.js'

const router = useRouter()
const store = useStore()

const handleAppBarClick = (actionItem) => {
  if (actionItem.handleClick) {
    actionItem.handleClick()
  }
}

const isLoggedIn = computed(() => store.state.user ? true : false)
const isRegistrationComplete = computed(() => store.state.isRegistrationComplete)
const drawer = ref(false)
const items = computed(() => {
  const computedItems = [
    {
      items: [
        { title: 'Home', href: 'https://adventurawr.ai', icon: 'mdi-home' },
      ],
    },
  ];

  if (isRegistrationComplete.value) {
    computedItems.push({
      group: 'Adventure',
      items: [
        { title: 'Current Quest', routeName: 'Adventure', icon: 'mdi-compass' },
        { title: 'Start New Adventure', routeName: 'AdventureCreate', icon: 'mdi-map-plus' },
        { title: 'My Adventures', routeName: 'AdventureList', icon: 'mdi-book-open-variant' },
        { title: 'Join Multiplayer Game', routeName: 'AdventureJoin', icon: 'mdi-account-group' },
      ],
    });
  }

  if (isLoggedIn.value) {
    const userItems = [];
    if (isRegistrationComplete.value) {
      userItems.push({ title: 'Profile', routeName: 'UserProfile', icon: 'mdi-account-circle-outline' });
      userItems.push({ title: 'Account', routeName: 'UserAccount', icon: 'mdi-cog' });
    }
    userItems.push({ title: 'Logout', action: 'logout', icon: 'mdi-logout' });
    computedItems.push({
      group: 'User',
      items: userItems,
    });
  } else {
    computedItems.push({
      group: 'User',
      items: [
        { title: 'Register', routeName: 'Register', icon: 'mdi-list-box-outline' },
        { title: 'Login', routeName: 'Login', icon: 'mdi-login' },
      ],
    });
  }

  return computedItems;
});

const handleNavItemClick = (action) => {
  if (action === 'logout') {
    handleSignOut();
  }
  drawer.value = false
}

const handleSignOut = () => {
  signOut(getAuth())
  store.dispatch('setUser', null)
  store.dispatch('setToken', null)
  store.dispatch('setAdventureId', null)
  store.dispatch('setIsRegistrationComplete', false)
  router.push('/')
}
</script>
<style scoped>
.social-icon {
  font-size: 21px;
}
</style>